import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

const FALLBACK = "https://images.unsplash.com/photo-1516890896652-41ca1a35787c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxjaGlsZHJlbiUyMHBsYXlpbmclMjBvdXRkb29ycyUyMHNvZnQlMjBsaWdodHxlbnwwfHx8fDE3ODM5NTg2MDd8MA&ixlib=rb-4.1.0&q=85";

export default function Timeline() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/posts", { params: { limit: 40 } })
      .then(({ data }) => setPosts(data))
      .finally(() => setLoading(false));
  }, []);

  const filtered = posts.filter((p) => {
    if (!q.trim()) return true;
    const s = q.toLowerCase();
    return (p.title || "").toLowerCase().includes(s) || (p.excerpt || "").toLowerCase().includes(s) || (p.category || "").toLowerCase().includes(s);
  });

  return (
    <div>
      <section className="border-b border-[hsl(var(--border))] bg-[hsl(var(--muted))]/50">
        <div className="container-cuidar py-14">
          <div className="text-xs font-semibold tracking-widest uppercase text-[hsl(var(--secondary))]">Timeline</div>
          <h1 className="mt-2 font-heading text-4xl sm:text-5xl font-black leading-tight">Postagens do instituto</h1>
          <p className="mt-4 max-w-2xl text-[hsl(var(--muted-foreground))]">
            Artigos, orientações e novidades pensados para famílias, cuidadores e profissionais que caminham com crianças neuroatípicas.
          </p>
          <div className="mt-6 flex gap-3 max-w-lg">
            <div className="relative flex-1">
              <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-[hsl(var(--muted-foreground))]" />
              <Input
                placeholder="Buscar por título, categoria…"
                value={q} onChange={(e) => setQ(e.target.value)}
                className="h-12 pl-10 rounded-full bg-white"
                data-testid="timeline-search-input"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="container-cuidar py-14">
        {loading && <div className="text-[hsl(var(--muted-foreground))]">Carregando postagens…</div>}
        {!loading && filtered.length === 0 && (
          <div className="surface p-10 text-center">
            <div className="font-heading text-lg font-bold">Nenhuma postagem por aqui ainda</div>
            <p className="text-sm text-[hsl(var(--muted-foreground))] mt-1">Volte em breve — novidades chegam toda semana.</p>
          </div>
        )}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {filtered.map((p, idx) => (
            <Link
              to={`/postagem/${p.id}`}
              key={p.id}
              data-testid={`timeline-post-card-${p.id}`}
              className={`group surface overflow-hidden block hover:-translate-y-0.5 transition-transform duration-300 fade-up ${idx < 4 ? `fade-up-${idx+1}` : ""}`}
            >
              <div className="h-48 overflow-hidden">
                <img src={p.cover_image || FALLBACK} alt={p.title}
                  className="h-full w-full object-cover group-hover:scale-[1.03] transition-transform duration-500" />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2">
                  <Badge className="rounded-full bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/15 border-transparent">
                    {p.category || "Postagem"}
                  </Badge>
                  <span className="text-xs text-[hsl(var(--muted-foreground))]">
                    {p.created_at ? new Date(p.created_at).toLocaleDateString("pt-BR") : ""}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-xl font-extrabold leading-snug line-clamp-2">{p.title}</h3>
                <p className="mt-2 text-sm text-[hsl(var(--muted-foreground))] line-clamp-3">{p.excerpt}</p>
                <div className="mt-4 text-xs text-[hsl(var(--muted-foreground))]">
                  por <span className="font-medium">{p.author_name || "Equipe Cuidar"}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
